<script>
import FeatherIcon from '../reusable/FeatherIcon.vue';

export default {
	components: { FeatherIcon },
};
</script>

<template>
	<section
		class="flex flex-col sm:justify-between items-center sm:flex-row mt-12 sm:mt-10"
	>
		<!-- Banner left contents -->
		<div class="w-full md:w-2/3 text-left">
			<h1
				class="font-general-semibold text-xl md:text-4xl xl:text-4xl text-center sm:text-left text-ternary-dark dark:text-primary-light uppercase"
			>
				Hi, I'm Alex
			</h1>
			<p
				class="font-general-medium mt-2 text-lg sm:text-xl  xl:text-2xl text-center sm:text-left leading-none text-gray-300"
			>
				Software Engineer
			</p>
			<p
				class="font-general-small mt-8 text-m sm:text-xl  xl:text-xl text-center sm:text-left leading-none text-gray-400"
			>
			I have a strong foundation in programming and gameplay development from Vancouver Film School. My passion for game design was sparked by creating a fun game for my kids, and now I aim to turn that passion into a career.
			</p>
			<div class="flex justify-center sm:block">
				<router-link
					to="/about"
					class="flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
				>
					<FeatherIcon
						name="arrow-down-circle"
						class="ml-0 sm:ml-1 mr-2 sm:mr-3 w-5 sm:w-6 duration-100"
					/>
					<span
						class="text-sm sm:text-lg font-general-medium duration-100"
						>More about me</span
					></router-link
				>
			</div>
		</div>

		<!-- Banner right illustration -->
		<div class="w-full md:w-8/12 text-right float-right" style="padding-left: 40px">
			<img
				style="width: 60%"
				src="@/assets/images/alexImage3.png"
				alt="Portrait of Alex Buzmion"
				decoding="async"
			/>
		</div>
	</section>
</template>

<style scoped></style>
